module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_suns-05c9b6d521c5aab9463618f098e1d77a.svg";